<template>
  <div class="wrap">
    <h1 class="row" style="text-align: center">{{translate('commercial-proforma-invoice')}}</h1>
    <table class="row">
      <tr>
        <td style="width: 50%; border-right: 1rem solid transparent" valign="top">
          <company-box
            :title="translate('ship-to')"
            :company="rfq.shipToCompany"
            :companyDetail="rfq.shipToCompanyDetail"
            :companyContact="rfq.shipToContact"
            :translate="translate"
          />
        </td>
        <td style="width: 50%; border-left: 1rem solid transparent" valign="top">
          <div class="box-content">
            <table>
              <tr>
                <td><div class="title">{{translate('commercial-proforma-invoice')}} {{translate('number-symbol')}}:</div></td>
                <td><div>{{invoice.invoiceNumber}}</div></td>
              </tr>
              <tr>
                <td><div class="title">{{translate('date')}}:</div></td>
                <td><div>{{invoice.invoiceDate | toDate}}</div></td>
              </tr>
              <tr>
                <td><div class="title">{{translate('order')}} {{translate('number-symbol')}}:</div></td>
                <td><div>{{invoice.po}}</div></td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
    </table>
    <table class="row box-content">
      <tr class="table__row">
        <th><div class="title">{{translate('ship-via')}}:</div></th>
        <th><div class="title">{{translate('account')}} {{translate('number-symbol')}}:</div></th>
        <th><div class="title uppercase">{{translate('awb')}}:</div></th>
        <th><div class="title">{{translate('number-symbol')}} {{translate('boxes')}}:</div></th>
        <th><div class="title">{{translate('country-origin')}}:</div></th>
      </tr>
      <tr class="table__row">
        <td align="center"><div>{{invoice.rfq.customerForwarder.shipper.shipperName}}</div></td>
        <td align="center"><div>{{invoice.rfq.customerForwarder.accountNumber}}</div></td>
        <td align="center"><div>{{invoice.awb}}</div></td>
        <td align="center"><div>{{invoice.totalPackages}}</div></td>
        <td align="center"><div class="uppercase">{{invoice.countryOrigin.title}}</div></td>
      </tr>
    </table>
    <table-list
      :columns="[
        {
          label: translate('qty'),
          renderColumn: (row) => row.qty
        },
        {
          label: translate('part-number'),
          renderColumn: (row) => row.part.partNumber
        },
        {
          label: translate('s/n'),
          renderColumn: (row) => row.partSN
        },
        {
          label: translate('description'),
          renderColumn: (row) => row.part.partDescription
        },
        {
          label: translate('condition'),
          renderColumn: (row) => row.condition.title
        },
        {
          label: translate('u/price'),
          renderColumn: (row) => $options.filters.toPrice(row.price)
        },
        {
          label: translate('total'),
          renderColumn: (row) => $options.filters.toPrice(row.price * row.qty)
        },
        {
          label: translate('currency'),
          renderColumn: (row) => row.currency.title
        }
      ]"
      :data="rfq3s"
    >
      <template v-slot="scope">
        <div>
          <span class="title">{{translate('release')}}:</span>
          <span>{{scope.item.tagInfoCompany.name}}; </span>
          <span>{{scope.item.release.title}}; </span>
          <span>{{scope.item.tagDate | toDate}}; </span>
        </div>
      </template>
    </table-list>
    <table class="row">
      <tr>
        <td style="width: 70%" valign="top">
          <div v-if="invoice.remark">
            <h3>{{translate('remarks')}}</h3>
            <p><span v-html="$options.filters.toTextarea(invoice.remark)"></span></p>
          </div>
        </td>
        <td>
          <table class="table-sum">
            <tr class="table__row">
              <td>
                <div class="capitalize">{{translate('sub-total')}}:</div>
              </td>
              <td><div>{{subTotal | toPrice}}</div></td>
            </tr>
            <tr class="table__row">
              <td><div class="capitalize">{{translate('vat')}}% {{invoice.vat.vatValue | toPrice}}:</div></td>
              <td><div>{{vatSum | toPrice}}</div></td></tr>
            <tr class="box-content table__row">
              <td><div class="capitalize">{{translate('total')}}:</div></td>
              <td><strong>{{total | toPrice}}</strong></td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <div class="row">
      <div v-html="content.html1"></div>
    </div>
  </div>
</template>
<script>
import { toDate, toPrice, toTextarea } from '@/utils/filters'
import TableList from './components/table-list'
import CompanyBox from './components/company-box'

export default {
  name: 'PdfInvoice10',
  components: {
    'table-list': TableList,
    'company-box': CompanyBox
  },
  props: {
    translate: {
      type: Function
    },
    invoice: {
      type: Object
    },
    rfq: {
      type: Object
    },
    rfq3s: {
      type: Array
    },
    content: {
      type: Object
    }
  },
  computed: {
    vatSum () {
      const vatPercent = (this.invoice.vat.vatValue || 0) / 100
      return (this.subTotal) * vatPercent
    },
    subTotal () {
      return this.rfq3s.reduce((result, detail) => result + (detail.qty * detail.price), 0)
    },
    total () {
      return this.subTotal + this.vatSum
    }
  },
  filters: {
    toPrice: toPrice,
    toDate: toDate,
    toTextarea: toTextarea
  }
}
</script>
